// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-bqisq{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-bendj{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-bvcbd{grid-column:span 6}.assets-scss-gridstyleGrid-col3-ccaff{grid-column:span 3}.assets-scss-gridstyleGrid-col4-boazb{grid-column:span 4}.assets-scss-gridstyleGrid-col9-bzute{grid-column:span 9}.assets-scss-gridstyleGrid-col12-uwyok{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-bpuzp{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-bqisq",
	"grid": "assets-scss-gridstyleGrid-grid-bendj",
	"col6": "assets-scss-gridstyleGrid-col6-bvcbd",
	"col3": "assets-scss-gridstyleGrid-col3-ccaff",
	"col4": "assets-scss-gridstyleGrid-col4-boazb",
	"col9": "assets-scss-gridstyleGrid-col9-bzute",
	"col12": "assets-scss-gridstyleGrid-col12-uwyok",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-bpuzp"
};
module.exports = ___CSS_LOADER_EXPORT___;
